import { useEffect } from 'react'
import { CommunicationObserver } from '@ocean/utils'
import { EventSubscriptionSettings } from '@ocean/utils/dist/CommunicationObserver'

const useCommunicationObserver = (events: EventSubscriptionSettings[]) => {
  useEffect(() => {
    events.forEach(event => {
      CommunicationObserver.subscribe(event)
    })
    return () => {
      events.forEach(event => {
        CommunicationObserver.unsubscribe(event)
      })
    }
  }, [events])

  return CommunicationObserver
}

export default useCommunicationObserver
